import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import instance from "@src/api/axiosInstance";
import config from '@src/api/config';
import { message } from 'antd';
import { noop } from 'lodash';

interface SavePromptInput {
  id?: string;
  title: string;
  prompt: string;
}

interface SavePromptResponse {
  success: boolean;
  prompt: {
    id: string;
    title: string;
    prompt: string;
  };
}

const savePrompt = async (input: SavePromptInput): Promise<SavePromptResponse> => {

  const url = input.id
    ? `/nexa/system-prompt/${input.id}/version`
    : '/nexa/system-prompt';

  const method = 'post';

  const response = await instance({
    url,
    method,
    data: input,
  });

  return response.data;
};

export function useSavePrompt({ onDone = noop }): UseMutationResult<
  SavePromptResponse,
  unknown,
  SavePromptInput
> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: savePrompt,
    onSuccess: () => {
      message.info('Prompt saved successfully');
      queryClient.invalidateQueries(['system-prompts']);
      queryClient.invalidateQueries(['system-prompt-versions']);
      onDone();
    },
  });
}
